// import React, { useEffect } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { store, rrfProps } from './FirebaseRedux';
import 'moment/locale/es';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { Box } from '@mui/material';
import AppRouter from './routing/AppRouter';
import { useEffect } from 'react';

function App() {
  const registerServiceWorker = () => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if ('serviceWorker' in navigator && isMobile && !isIOS) {
      navigator.serviceWorker.getRegistration().then(async (registration: any) => {
        if (!registration) {
          registration = await navigator.serviceWorker.register('/service-worker.js');
          // Esperar hasta que el Service Worker esté activo
          await navigator.serviceWorker.ready;
        }
      });
    }
  };

  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <Box className="App" sx={{ maxWidth: '100%', overflowX: 'auto' }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Provider store={store}>
            <ReactReduxFirebaseProvider {...rrfProps}>
              <AppRouter />
            </ReactReduxFirebaseProvider>
          </Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Box>
  );
}

export default App;
